$(document).ready(function() {
    const $stationWidgetPlace = $('.service_station');

    $.ajax({
        url: new URL('/api/v1/stations', document.baseURI),
        data: {
            'StationSearch': {
                active: 'Y',
            },
        },
        success: function (data) {
            $stationWidgetPlace.prepend('<div class="service_station_list"></div>')
            for (const item of data) {
                $stationWidgetPlace
                    .children('.service_station_list')
                    .append(`
                        <div class="service_station_item">
                            <h3 class="b-header_item-name">${item.name}</h4>
                            <p>Адрес: ${item.addr}</p>
                            <p>Адрес: ${item.phone ? item.phone : ''}</p>
                        </div>
                    `)
            }
        }
    })
})
